import { Component, Input, OnChanges } from "@angular/core";
import { orderBy } from "lodash";

@Component({
  selector: "ab-deploys-with-errors",
  templateUrl: "./deploys-with-errors.component.html",
})
export class DeploysWithErrorsComponent implements OnChanges {
  @Input() public deployData: any;
  @Input() public loading: boolean;
  @Input() public project: any;
  @Input() public projects: any;

  public MAX_DEPLOYS_TO_DISPLAY = 5;
  public deploys: any[];

  public ngOnChanges() {
    if (this.deployData == null) {
      return;
    }
    if (this.deployData.deploys == null) {
      this.deploys = [];
      return;
    }

    const deploys = orderBy(
      this.deployData.deploys,
      ["groupCreatedCount"],
      ["desc"],
    ).slice(0, this.MAX_DEPLOYS_TO_DISPLAY);

    this.deploys = this.project
      ? deploys
      : this.addProjectNames(deploys, this.projects);
  }

  public trackById(_index: number, item: any) {
    return item.id;
  }

  private addProjectNames(deploys: any[], projects: any[]) {
    return deploys.map((deploy: any) => {
      for (const project of projects) {
        if (project.id === deploy.projectId) {
          deploy.projectName = project.name;
          break;
        }
      }
      return deploy;
    });
  }
}
